<div class="pageheader">
    <div class="page-title">
        <h1>Nuget feeds</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh(true)">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
        </div>
    </div>
</div>

<div class="btn-toolbar">
    <div class="btn-group">
        <button class="btn btn-primary" (click)="openFeedConfiguration()">Feed configuration</button>
    </div>
</div>

<hr />

<div class="row">
    <div class="col-md-12">
        <div class="row">
            <div class="col-md-3">
                <div class="mycontent-left">
                    <h2>Configured feeds</h2>
                    <div>
                        <label>
                            <input type="checkbox" [(ngModel)]="includePrerelease" /> Include prerelease
                        </label>
                        <br>

                        <button class="btn btn-link btn-feed-search" type="button" (click)="refresh(true)">Reset</button>
                        <button class="btn btn-primary btn-feed-search" type="button" (click)="refresh(false)">Search</button>
                        <div class="feed-search">
                            <input class="form-control" type="text" [(ngModel)]="searchTerm" />
                        </div>

                        <br>

                        <dx-tree-view #feedTreeView class="nuget-treeview" id="feed-treeview" [dataSource]="nugetFeeds" [expandNodesRecursive]="false" itemsExpr="Packages" width="100%"
                            [searchEnabled]="false" searchMode="contains" itemTemplate="itemTemplate" noDataText="No configured nuget feeds" (onItemClick)="treeViewItemClick($event)">
                            <div *dxTemplate="let itemObj of 'itemTemplate'">
                                @if (itemObj.LoadError) {
                                <div [title]="itemObj.LoadError"><img class="tree-icon" [src]="getIconUrl(itemObj)" /><i>{{getText(itemObj)}}</i></div>
                                }
                                @else {
                                <div><img class="tree-icon" [src]="getIconUrl(itemObj)" />{{getText(itemObj)}}</div>
                                }


                            </div>
                        </dx-tree-view>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="mycontent-right">

                    @if (currentSelection()?.NugetFeedPackage) {

                    <div id="package-details">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <img class="package-icon" [src]="currentSelection()?.NugetFeedPackage.IconUrl ?? '/images/nuget-package.png'" width="40px" height="40px" />
                                    <div class="package-title">{{currentSelection()?.NugetFeedPackage.Title}}</div>
                                </div>
                            </div>
                        </div>

                        <br>

                        <div class="container">
                            <div class="row">
                                <div class="col-md-12 markdown">
                                    <markdown [data]="currentDescription()"></markdown>
                                </div>
                            </div>
                        </div>

                        <br>

                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <b>Version</b>
                                        </div>
                                        <div class="col-md-10">
                                            {{currentSelection()?.NugetFeedPackage.Identity.Version.OriginalVersion}}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <b>Author(s)</b>
                                        </div>
                                        <div class="col-md-10">
                                            {{currentSelection()?.NugetFeedPackage.Authors}}
                                        </div>
                                    </div>

                                    @if (currentSelection()?.NugetFeedPackage.DownloadCount) {
                                    <div class="row">
                                        <div class="col-md-2">
                                            <b>Downloads</b>
                                        </div>
                                        <div class="col-md-10">
                                            {{currentSelection()?.NugetFeedPackage.DownloadCount}}
                                        </div>
                                    </div>
                                    }

                                    @if (currentSelection()?.NugetFeedPackage.LicenseUrl) {
                                    <div class="row">
                                        <div class="col-md-2">
                                            <b>License</b>
                                        </div>
                                        <div class="col-md-10">
                                            <a [href]="$safeNavigationMigration(currentSelection()?.NugetFeedPackage.LicenseUrl)" target="_blank">Licence</a>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <br>

                        <app-collapsible-group (collapsedChange)="onContentPanelStateChange($event)" [(collapsed)]="packageContentHidden">
                            <h4 title>Package content</h4>

                            @if (isLoadingPackageContent) {

                            <div class="nuget-load-panel">
                                <dx-load-indicator id="small-indicator" height="25px" width="25px">
                                </dx-load-indicator>
                                <h4>&nbsp;Downloading package...</h4>
                            </div>

                            }
                            @else {

                            <div>
                                @if (currentPackageXmlContent.length > 0 || currentPackageAssemblyContent.length > 0) {
                                <div>
                                    <ul>
                                        @for (file of currentPackageXmlContent; track file) {
                                        <li>
                                            <span>{{file.Filename}} @if (!file.ArtifactId) {
                                                <img src="/images/new-artifact.png" height="20px" width="20px" />
                                                }</span>
                                        </li>
                                        }
                                    </ul>
                                    <ul>
                                        @for (file of currentPackageAssemblyContent; track file) {
                                        <li>
                                            <span>{{file.Filename}} @if (!file.ArtifactId) {
                                                <img src="/images/new-artifact.png" height="20px" width="20px" />
                                                }</span>
                                        </li>
                                        }
                                    </ul>
                                </div>

                                }
                                @else {

                                <div>
                                    <i>This package contains no Link artifacts</i>
                                </div>

                                }
                            </div>

                            }
                        </app-collapsible-group>

                        <br>

                        <button class="btn btn-primary" (click)="installCurrentPackage()">Install package</button>
                    </div>

                    }
                    @else {

                    <div id="package-details">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>{{currentSelection()?.NugetFeed.Name}}</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <a target="_blank" href="{{currentSelection()?.NugetFeed.Url}}">{{currentSelection()?.NugetFeed.Url}}</a>
                            </div>
                        </div>
                    </div>

                    }
                </div>
            </div>
        </div>
    </div>
</div>
